import PropTypes from 'prop-types';
import { Record } from 'immutable';
import { recordOf } from 'react-immutable-proptypes';

const NintendoAccountRecord = new Record({
  id: undefined,
  name: undefined,
  selected: false,
});

export default class NintendoAccount extends NintendoAccountRecord {
  static PropTypes = recordOf({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    selected: PropTypes.bool,
  })
  toggle() {
    return this.set('selected', !this.selected);
  }
  select() {
    return this.set('selected', true);
  }
  unselect() {
    return this.set('selected', false);
  }
}
